import { Modal } from "@circleco/compass/components/Modal";

import { t } from "@/i18n-js/instance";

interface ConfirmationModalProps {
  isLoading: boolean;
  memberName?: string;
  onConfirm: () => void;
  onOpenChange: (open: boolean) => void;
  open: boolean;
  spaceName: string;
}

export const ConfirmationModal = ({
  isLoading,
  memberName,
  onConfirm,
  onOpenChange,
  open,
  spaceName,
}: ConfirmationModalProps) => (
  <Modal.Root open={open} onOpenChange={onOpenChange} size="md">
    <Modal.Content>
      <Modal.Header title={t("remove")} />
      <Modal.Body>
        {t("members_directory.community_members.actions.space.confirm_remove", {
          community_member: memberName,
          space: spaceName,
        })}
      </Modal.Body>
      <Modal.Footer
        secondaryAction={{
          label: t("cancel"),
          onClick: () => onOpenChange(false),
          shouldCloseModal: false,
        }}
        primaryAction={{
          label: isLoading ? t("removing") : t("remove"),
          variant: "destructive",
          disabled: isLoading,
          onClick: onConfirm,
        }}
      />
    </Modal.Content>
  </Modal.Root>
);
